<template>
  <section>
    <h2>Support Us</h2>
    <p>I love doing this and want to do more.</p>
    <p><strong>The CR Market</strong> is a part of the <a href="https://elementnova.com/" target="_blank">Element Nova</a> Network.</p>
    <p>Through your support I'm able to keep this site up to date, work on new features, and build new products for gamers and fans.</p>
    <p>Please consider supporting The CR Market and Element Nova at our <a href="https://ko-fi.com/elementnova/goal?g=7" target="_blank">Ko-Fi</a> so we can continue creating great things for users like you.</p>
  </section>
</template>

<script>
export default {
  name: 'SupportUs'
}
</script>


// WEBPACK FOOTER //
// SupportUs.vue?21461c3e